import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import GuideStyles from "assets/js/guide";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

export default function GuideTemplate() {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = data => {
    console.log("data", data);
  };

  const handleChangePw = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
    console.log("event.target.value", event.target.value);
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Template - Form</h2>
          </div>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box className="box-type-5">
            <FormControl variant="outlined">
              <InputLabel>간편 비밀번호</InputLabel>
              <OutlinedInput
                id="pw"
                type={values.showPassword ? "tel" : "password"}
                // value={values.password}
                onChange={handleChangePw("password")}
                placeholder="간편 비밀번호 입력"
                aria-describedby="error-pw"
                {...register("pw", { required: true })}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="view"
                      type="button"
                      className={
                        values.showPassword ? "btn-view-off" : "btn-view"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    />
                  </InputAdornment>
                }
              />
              {errors.pw?.type === "required" && (
                <FormHelperText id="error-pw" className="error">
                  숫자 6자리를 입력해주세요.
                </FormHelperText>
              )}
            </FormControl>
          </Box>

          <Divider className="divider-type-2" />

          <Box className="box-type-5">
            <Grid container spacing={1} className="form-group-wrap">
              <Grid item xs={12} md={6}>
                <FormControl>
                  <InputLabel>휴대폰 번호</InputLabel>
                  <OutlinedInput type="tel" value="010-1234-5678" disabled />
                </FormControl>
              </Grid>
              <Grid item xs={8} md={6}>
                <FormControl>
                  <InputLabel>생년월일</InputLabel>
                  <OutlinedInput type="tel" value="940918" disabled />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={6}>
                <FormControl>
                  <InputLabel>성별</InputLabel>
                  <OutlinedInput type="text" value="여성" disabled />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <InputLabel required>이메일</InputLabel>
                <Grid container spacing={1} className="inner-grid">
                  <Grid item xs={12}>
                    <Grid container spacing={1} className="item-grid">
                      <Grid item xs>
                        <OutlinedInput type="text" />
                      </Grid>
                      <Grid item xs={1}>
                        <span className="color-disabled">@</span>
                      </Grid>
                      <Grid item xs>
                        <Select value={1}>
                          <MenuItem value={0}>직접입력</MenuItem>
                          <MenuItem value={1}>naver.com</MenuItem>
                          <MenuItem value={2}>Twenty</MenuItem>
                          <MenuItem value={3}>Thirty</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <OutlinedInput
                      id="email"
                      type="text"
                      placeholder="직접입력"
                      aria-describedby="error-email"
                      {...register("email", { required: true })}
                    />
                    {errors.email?.type === "required" && (
                      <FormHelperText id="error-email" className="error">
                        이메일을 입력해주세요.
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <InputLabel required>주소</InputLabel>
                <Grid container spacing={1} className="inner-grid">
                  <Grid item xs={12}>
                    <Grid container spacing={1} className="item-grid">
                      <Grid item xs={7}>
                        <OutlinedInput
                          type="text"
                          readOnly
                          id="postcode"
                          aria-label="postcode"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <Button variant="contained" color="common">
                          우편번호 검색
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <OutlinedInput
                      type="search"
                      value="서울특별시 중구 퇴계로 68길 99"
                      id="address"
                      readOnly
                      aria-label="address"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <OutlinedInput
                      defaultValue="7층"
                      aria-label="address-detail"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <div className="btn-bottom-wrap">
            <Button fullWidth variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </main>
    </>
  );
}
